import { GlobalStyles } from "types/theme";

import { cssResets } from "./reset";

export const globalStyles: GlobalStyles = () => ({
  ...cssResets,
  html: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  body: {
    display: "flex !important",
    flexDirection: "column",
    flex: 1,
  },
  "#root": {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
});
